import { Dispatch, SetStateAction, useState, useEffect } from "react";
import { DecrireSituation } from "./decrireSituation";
import { CompareProtection } from "./compareProtection";
import { Secteurs, wrapper } from "core";
import { MentionsLegales } from "components/ui/Simulation/MentionsLegales";

const Simulation = ({
  updateTotal,
  toggleState,
  setToggleState,
  category,
}: {
  updateTotal: (total: number) => void;
  toggleState: number;
  setToggleState: Dispatch<SetStateAction<number>>;
  category: Secteurs;
}) => {
  const [toggleResultat, setToggleResultat] = useState(false);

  // Réinitialiser toggleResultat quand on retourne à l'étape 1
  // pour forcer la revalidation de la franchise lors d'une nouvelle simulation
  useEffect(() => {
    if (toggleState === 1) {
      setToggleResultat(false);
    }
  }, [toggleState]);

  const handleSimulation = () => {
    setToggleResultat(true);
  };
  const handleToggleState = () => {
    wrapper.setTcVars({
      evt_action_libelle: "SAC_simuler_perte",
    });
    setToggleState(2);
  };

  console.log(toggleResultat);
  return (
    <div className="font-openSansBold">
      {toggleState === 1 ? (
        <DecrireSituation
          category={category}
          updateTotal={updateTotal}
          toggleState={toggleState}
          handleToggleState={handleToggleState}
          handleSimulation={handleSimulation}
        />
      ) : (
        <CompareProtection
          category={category}
          toggleResultat={toggleResultat}
          setToggleResultat={setToggleResultat}
        />
      )}
      <MentionsLegales
        variant={toggleResultat === false ? "primary" : "secondary"}
      />
    </div>
  );
};

export default Simulation;
